import type { FormEvent } from 'react';
import React from 'react';

import { FormField, FormHelp, Label, Text, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { RECYCLING_PROCEDURES } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RecyclingProcedure({ section, setSectionValues }: Props): JSX.Element {
  function onDescriptionChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  return (
    <>
      <Text fontType="h6">Recycling procedures</Text>
      <FormField marginTop="xs">
        <Label id="recycling-procedure-description">Describe the building recycling procedures</Label>
        <Textarea
          aria-labelledby="recycling-procedure-description"
          onChange={onDescriptionChange}
          value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.DESCRIPTION)}
          resize="vertical"
        />
        <FormHelp>
          This should include the location of recycling and composting area(s), description of recycling and composting
          containers, how to discard large items and hazardous materials, and where to go for more information. These
          procedures apply to all residents, housekeepers, guests, subtenants, homecare workers, and other visitors.
        </FormHelp>
      </FormField>
    </>
  );
}
